const state = {
    sessions: {
        session01: [
            {
                title: "의료인의 소셜미디어 사용의 윤리",
                speaker: ["김한나 (연세의대 인문사회의학교실)"],
                videoId: "1-1"
            },
            {
                title: "최근 의료광고 관련 법률 문제들",
                speaker: ["박지용 (연세대 법학전문대학원)"],
                videoId: "1-2"
            },
            {
                title: "질의응답",
                speaker: [
                    "김병식 (한양의대 심장내과)",
                    "류영상 (조선의대 내분비내과)"
                ],
                videoId: "1-3"
            }
        ],
        session02: [
            {
                title: "Evidence-Based Exercise Strategies for Cholesterol Management",
                speaker: ["이동훈 (연세대 스포츠응용산업학과)"],
                videoId: "2-1"
            },
            {
                title: "Nutrition-Based Approaches to Managing Cholesterol",
                speaker: ["배윤정 (국립한국교통대 식품영양학)"],
                videoId: "2-2"
            },
            {
                title: "질의응답",
                speaker: [
                    "백진경 (을지대 식품영양학과)",
                    "조준환 (중앙의대 순환기내과)"
                ],
                videoId: "2-3"
            }
        ],
        session03: [
            {
                title: "Pro : Statin 단독이 우선된다",
                speaker: ["류영상 (조선의대 내분비내과)"],
                videoId: "3-1"
            },
            {
                title: "Cons : Statin + Ezetimibe 복합요법이 우선된다",
                speaker: ["김병식 (한양의대 심장내과)"],
                videoId: "3-2"
            },
            {
                title: "질의응답",
                speaker: [
                    "박수정 (한양의대 심장내과)",
                    "신민혁 (원광의대 내분비내과)"
                ],
                videoId: "3-3"
            }
        ],
        session04: [
            {
                title: "GLP-1 RA in the Prevention of Obesity-Related Cardiovascular Disease",
                speaker: ["오석 (전남의대 순환기내과)"],
                videoId: "4-1"
            },
            {
                title: "Obesity Medication and Heart Failure",
                speaker: ["서미혜 (순천향의대 내분비내과)"],
                videoId: "4-2"
            },
            {
                title: "질의응답",
                speaker: [
                    "김현아 (중앙보훈병원 내분비내과)",
                    "노정현 (인제의대 내분비내과)"
                ],
                videoId: "4-3"
            }
        ],
        session05: [
            {
                title: "새로운 고지혈증 치료제에 의한 지질대사의 조절",
                speaker: ["박상규 (연세 원주의대 생화학교실)"],
                videoId: "5-1"
            },
            {
                title: "최신 이상지질혈증 치료제 언박싱(Unboxing)",
                speaker: ["김규호 (가톨릭의대 내분비내과)"],
                videoId: "5-2"
            },
            {
                title: "질의응답",
                speaker: [
                    "김남훈 (고려의대 내분비내과)",
                    "위진 (가천의대 심장내과)"
                ],
                videoId: "5-3"
            }
        ],
        session06: [
            {
                title: "Lipoprotein(a) 만 높은 환자는 어떻게 접근해야하나요?",
                speaker: ["장영우 (가천의대 심장내과)"],
                videoId: "6-1"
            },
            {
                title: "Statin 을 써도 Non-HDL-C 이나 ApoB 가 높은 환자는 어떻게 접근하나요?",
                speaker: ["김현진 (한양의대 심장내과)"],
                videoId: "6-2"
            },
            {
                title: "질의응답",
                speaker: [
                    "서미혜 (순천향의대 내분비내과)",
                    "유지희 (중앙의대 내분비내과)"
                ],
                videoId: "6-3"
            }
        ],
    },
};

const mutations = {
 
};

const actions = {
   
};

const getters = {
    getSessions: state => key => {
        return state.sessions[key] || [];
    },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};